/* eslint-disable no-undef */
export default {
	name: "zone-product-pricing-add-update-table",
	props: ["zones", "numberOfDecimalPlaces"],
	emits: ["zoneSelected"],
	data() {
		return {
			zonesPricing: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			precision: 2
		};
	},
	methods: {
		onQuantityInput(product){
			console.log("product.selected", product.selected);
			if(product.quantity === null || product.quantity === ""){
				product.quantity = 1;
			}
			else if(product.quantity <= 0){
				product.quantity = 1;
			}
			product.total = product.quantity * product.price;
			this.calculateGrandTotalForOrder();
			this.onProductSelect();
		},
		calculateGrandTotalForOrder(){
			this.orderTotal = 0;
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					this.orderTotal += this.products[i].total;
				}
			}
		},
		onZoneSelect(){
			let selectedZones = [];
			for(let i = 0; i < this.zonesPricing.length; i++){
				if(this.zonesPricing[i].selected){
					if(this.zonesPricing[i].price !== null)
					{
						let selectedZone = {
							zoneId: this.zonesPricing[i].zoneId,
							price: this.zonesPricing[i].price,
							zoneProductBasePriceId: this.zonesPricing[i].zoneProductBasePriceId
						}
						selectedZones.push(selectedZone);
					}
				}
			}
			this.$emit("zoneSelected", selectedZones);
		}
	},
	mounted: function () {
		//this.getZones();
	},
	watch:{
		zones:{
			handler: function (){
				if(this.zones !== null && this.zones.length > 0){
					this.zonesPricing = this.zones;
				}
			},
			immediate: true,
			deep: true
		},
		numberOfDecimalPlaces:{
			handler: function (){
				if(this.numberOfDecimalPlaces){
					this.precision = this.numberOfDecimalPlaces;
				}
			},
			immediate: true,
			deep: true
		},
		// canClearZones: {
		// 	handler: function () {
		// 		if (this.canClearZones) {
		// 			this.getZones();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// }
	}
};
